import { observer } from "mobx-react-lite";
import DetailBar, { DetailBarStripe } from "../../components/DetailBar";
import { Modal } from "../../components/Modal";
import SimpleSwitch from "../../components/SimpleSwitch";
import DepthIcon from "../../icons/DepthIcon";
import FrameStripsIcon from "../../icons/FrameStripsIcon";
import Height2Icon from "../../icons/Height2Icon";
import LengthIcon from "../../icons/LengthIcon";
import WidthIcon from "../../icons/WidthIcon";
import { store } from "../../stores/Store";
import { publicUrl } from "../../utils/url";
import Img from "../../components/Img";
import FrameThicknessIcon from "../../icons/FrameThicknessIcon";
import HeadboardThicknessIcon from "../../icons/HeadboardThicknessIcon";
import InfoBar from "../../components/InfoBar";
import { RenderIf } from "../../components/RenderIf";
import DrawerDepthIcon from "../../icons/DrawerDepthIcon";
import { _t } from '../../utils/Lang';

function Icon({ paramName }) {
    // extra_length
    // extra_width
    // height
    // seating_depth
    // frame_slat_count
    switch (paramName) {
        case 'extra_width':
            return <WidthIcon />
        case 'extra_length':
            return <LengthIcon />
        case 'height':
            return <Height2Icon />
        case 'seating_depth':
        case 'mattress_recess_depth':
            return <DepthIcon />
        case 'frame_slat_count':
            return <FrameStripsIcon />
        case 'frame_thickness':
            return <FrameThicknessIcon />
        case 'headboard_thickness':
            return <HeadboardThicknessIcon />
        case 'area_icon':
            return <HeadboardThicknessIcon />
        case 'depth_bedding_container':
            return <DrawerDepthIcon />
        default:
            return null;
    }
}

const DimensionsModal = observer(props => {

    // const selectedDimension = store.dimensionOptions.find(item => item.valueId === store.selectedDimesionId);
    const step = store.getStepByType('radio_dimensions');
    const previewDimension = step?.previewOption || step?.selectedOption;
    const { width = 0, length = 0, valueId: selectedDimensionId } = previewDimension || {};

    const frame_thickness = parseInt(store.dimensionAttributes.find(item => item.name === 'frame_thickness')?.value) || 0;
    const headboard_thickness = parseInt(store.dimensionAttributes.find(item => item.name === 'headboard_thickness')?.value) || 0;
    const extra_width = parseInt(store.dimensionAttributes.find(item => item.name === 'extra_width')?.value) || 0;
    const headboard_height = store.getStepByType('select_headboard')?.selectedOption?.height || 0;
    const side_panels_width = store.getStepByType('side_panels_width')?.selectedOption?.panel_width || 0;
    const extra_height = store.getStepByType('select_headboard')?.selectedOption?.extra_height || 0;
    const headboard_width_add = parseInt(String(store.getStepByType('select_headboard_width')?.selectedOption?.name).replaceAll(/[^0-9]/g, '')) || 0;

    const legs_height = store.getStepByType('select_legs')?.selectedOption?.height || 0;
    const add_legs_to_height = store.product?.add_legs_to_height;

    if (!step) {
        return null
    }

    // debugger;
    return <Modal
        onClose={e => {
            store.closeDimensions();
        }}
        isOpen={store.isOpenDimensions}
        style={{ zIndex: 1010 }}

    >
        <div className="ModalSizes">
            <div className='c-h1'>{_t('full_dimensions')}</div>
            <div className='text-center relative' style={{ aspectRatio: '16/9' }} >
                <Img className='d-block m-auto' src={store.renderDimensionsPreviewImageUrl} alt="" />
            </div>
            <div className="c-h2">{_t('dimensions_title')}</div>
            <RenderIf condition={store.dimensionsOptions.showControls}>
                <div className="d-grid g-2 grid-cols-3 grid-cols-lg-5 pb-2">
                    {
                        step.filteredOptions.map((item, index) => {
                            return <SimpleSwitch
                                className="SimpleSwitch--fullbg"
                                key={index}
                                name={item.name}
                                icon={item.icon}
                                selectedPriceVariant={item.selectedPriceVariant}
                                price={item.relativePrice}
                                showPrice={true}
                                showChecked={false}
                                onClick={() => {

                                    // store.updateOption(step.id, item.valueId);
                                    store.updateOptionPreview(step.id, item.valueId);

                                }}
                                checked={item.valueId === step.previewValue}


                            />
                        })
                    }

                </div>
                <div className="pb-2">

                    {step.hasFilteredOptions ? (
                        <>
                            <InfoBar onClick={() => {
                                step.filterOptions(!step.areOptionsFiltered)
                            }}>
                                <RenderIf condition={step.areOptionsFiltered}>
                                    <span dangerouslySetInnerHTML={{ __html: _t('non_standard_size') }} />
                                </RenderIf>
                                <RenderIf condition={!step.areOptionsFiltered}>
                                    <u>{_t('standard_view')}</u>
                                </RenderIf>
                            </InfoBar>
                        </>
                    ) : null}
                </div>
            </RenderIf>



        </div>

        <DetailBarStripe>
            {
                store.dimensionAttributes.map((item, index) => {
                    // Długość całkowita = długość powierzchni spania (2 m) + grubość ramy + grubość wezgłowia
                    // Szerokość całkowita = Szerokość powierzchni spania + 2 x grubość ramy
                    // Wysokość całkowita = Wysokość wybranego wariantu wezgłowia (ew. + 18 cm wysokośc nóżki dla łóżek na nóżkach)
                    let val = item.value;
                    let suffix = ' cm';
                    if (item.name === 'extra_width') {
                        val = width + extra_width + headboard_width_add * 2 + side_panels_width * 2;
                    }
                    if (item.name === 'extra_length') {
                        // console.log(`${length} + ${val} + ${headboard_thickness}`);
                        val = parseInt(val) + parseInt(length);
                    }
                    if (item.name === 'height') {
                        val = item.value;
                        if (item.value) {
                            val = parseInt(item.value);
                        }
                        if (extra_height) {
                            val += parseInt(extra_height)
                        }
                        if (headboard_height) {
                            val += parseInt(headboard_height)
                        }
                        if (legs_height && add_legs_to_height) {
                            val += parseInt(legs_height)
                        }


                    }
                    if (item.name === 'mattress_recess_depth') {
                        suffix = '';
                    }
                    if (!val) {
                        return null;
                    }

                    return <DetailBar key={index} icon={<Icon paramName={item.name} />}>
                        <div className="DetailBar__label">{item.label}: </div>
                        <div className="DetailBar__value">{val}{suffix}</div>
                    </DetailBar>

                })
            }
            {
                store.previewDimension ? (
                    <DetailBar icon={<Icon paramName={'area_icon'} />}>
                        <div className="DetailBar__label">{_t('sleep_surface')} </div>
                        <div className="DetailBar__value">{store.previewDimension.name}</div>
                    </DetailBar>

                ) : null
            }


            {/* <DetailBar icon={<LengthIcon />}>
                <div className="DetailBar__label">Długość całkowita: </div>
                <div className="DetailBar__value">176 cm</div>
            </DetailBar>

            <DetailBar icon={<Height2Icon />}>
                <div className="DetailBar__label">Wysokość całkowita: </div>
                <div className="DetailBar__value">176 cm</div>
            </DetailBar>

            <DetailBar icon={<DepthIcon />}>
                <div className="DetailBar__label">Głębokość osadzenia materaca: </div>
                <div className="DetailBar__value">146 cm</div>
            </DetailBar>
            <DetailBar icon={<FrameStripsIcon />}>
                <div className="DetailBar__label">Ilość listew stelaża: </div>
                <div className="DetailBar__value">25</div>
            </DetailBar> */}

        </DetailBarStripe>

        <div className="d-flex a-center my-2" style={{ lineHeight: 1.2 }}>
            <svg className="mr-1 shrink-0" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8 11.3333V8M8 4.66667H8.00833M4.5 15.5H11.5C12.9001 15.5 13.6002 15.5 14.135 15.2275C14.6054 14.9878 14.9878 14.6054 15.2275 14.135C15.5 13.6002 15.5 12.9001 15.5 11.5V4.5C15.5 3.09987 15.5 2.3998 15.2275 1.86502C14.9878 1.39462 14.6054 1.01217 14.135 0.772484C13.6002 0.5 12.9001 0.5 11.5 0.5H4.5C3.09987 0.5 2.3998 0.5 1.86502 0.772484C1.39462 1.01217 1.01217 1.39462 0.772484 1.86502C0.5 2.3998 0.5 3.09987 0.5 4.5V11.5C0.5 12.9001 0.5 13.6002 0.772484 14.135C1.01217 14.6054 1.39462 14.9878 1.86502 15.2275C2.3998 15.5 3.09987 15.5 4.5 15.5Z" stroke="#212121" strokeLinecap="round" strokeLinejoin="round" />
            </svg>

            <div>{_t('dim_tolerance_info')}</div>
        </div>


    </Modal>

});
DimensionsModal.displayName = 'DimensionsModal';

export default DimensionsModal